import React, { useEffect, useState } from "react";
import "./../assets/style/agencies.css";
import Header from "./../components/header";
import AppModal from "../components/AppModal";
import AddAgency from "../components/agencies/AddAgency";
import AgencyRow from "../components/agencies/AgencyRow";
import { getAllAgent } from "../api/services";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Grid } from "@mui/material";
import Sidebar from "./../components/Sidebar";

const Agencies = () => {
  const [isAddAgentOpen, setIsAddAgentOpen] = useState(false);
  const [agent, setAgent] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const openModal = () => {
    setIsAddAgentOpen(true);
  };

  const closeModal = () => {
    setIsAddAgentOpen(false);
  };

  const showAddAgentModal = () => {
    if (isAddAgentOpen) closeModal();
    else openModal();
  };

  useEffect(() => {
    if (window.localStorage.getItem("login")) {
      agentInit();
    }
  }, []);
  //get all agent
  const agentInit = () => {
    getAllAgent().then((response) => {
      if (response.success) {
        setAgent(response.data.user);
      } else {
        toast.error(response.message, {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    });
  };

  return (
    <>
      <Header />
      <Grid container sx={{ flexGrow: 1 }}>
        <Grid item xs={0} md={2.3} xl={1.7}>
          <Sidebar />
        </Grid>
        <Grid item xs={12} md={9.7} xl={10.3}>
          <div className="dashboard adds">
            <ToastContainer />

            <div className="in">
              <div>
                <div className="upr12">
                  <p className="addsHeader">Registered Agencies</p>
                  <button onClick={showAddAgentModal}>
                    <svg
                      width="19"
                      height="19"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g id="Upload">
                        <path
                          id="Vector"
                          d="M5.21783 18.9384L5.1005 19.6792H5.1005L5.21783 18.9384ZM1.06156 14.7822L1.80232 14.6648L1.06156 14.7822ZM18.9384 14.7822L19.6792 14.8995V14.8995L18.9384 14.7822ZM14.7822 18.9384L14.8995 19.6792H14.8995L14.7822 18.9384ZM18.6 8.54956C18.3513 8.21837 17.8811 8.15156 17.5499 8.40032C17.2187 8.64909 17.1519 9.11924 17.4007 9.45043L18.6 8.54956ZM2.59931 9.45043C2.84808 9.11924 2.78126 8.64909 2.45007 8.40032C2.11888 8.15156 1.64873 8.21837 1.39996 8.54956L2.59931 9.45043ZM9.25 15C9.25 15.4142 9.58579 15.75 10 15.75C10.4142 15.75 10.75 15.4142 10.75 15H9.25ZM5.41232 4.53403C5.15497 4.8586 5.20946 5.33034 5.53403 5.58768C5.8586 5.84503 6.33034 5.79054 6.58768 5.46597L5.41232 4.53403ZM7.39785 3.23703L6.81016 2.77106L7.39785 3.23703ZM12.6022 3.23703L13.1898 2.77106L12.6022 3.23703ZM13.4123 5.46597C13.6697 5.79054 14.1414 5.84503 14.466 5.58768C14.7905 5.33034 14.845 4.8586 14.5877 4.53403L13.4123 5.46597ZM9.74934 1.01989L9.63133 0.279231L9.63133 0.279232L9.74934 1.01989ZM10.2507 1.01989L10.3687 0.279232L10.3687 0.279231L10.2507 1.01989ZM18.25 12V13H19.75V12H18.25ZM13 18.25H7V19.75H13V18.25ZM1.75 13V12H0.25V13H1.75ZM7 18.25C6.04233 18.25 5.65082 18.2477 5.33515 18.1977L5.1005 19.6792C5.56216 19.7523 6.09965 19.75 7 19.75V18.25ZM0.25 13C0.25 13.9003 0.247672 14.4378 0.320792 14.8995L1.80232 14.6648C1.75233 14.3492 1.75 13.9577 1.75 13H0.25ZM5.33515 18.1977C3.51661 17.9096 2.09035 16.4834 1.80232 14.6648L0.320792 14.8995C0.710478 17.3599 2.64012 19.2895 5.1005 19.6792L5.33515 18.1977ZM18.25 13C18.25 13.9577 18.2477 14.3492 18.1977 14.6648L19.6792 14.8995C19.7523 14.4378 19.75 13.9003 19.75 13H18.25ZM13 19.75C13.9003 19.75 14.4378 19.7523 14.8995 19.6792L14.6648 18.1977C14.3492 18.2477 13.9577 18.25 13 18.25V19.75ZM18.1977 14.6648C17.9096 16.4834 16.4834 17.9096 14.6648 18.1977L14.8995 19.6792C17.3599 19.2895 19.2895 17.3599 19.6792 14.8995L18.1977 14.6648ZM19.75 12C19.75 10.7064 19.3219 9.51064 18.6 8.54956L17.4007 9.45043C17.9342 10.1607 18.25 11.0424 18.25 12H19.75ZM1.75 12C1.75 11.0424 2.06583 10.1607 2.59931 9.45043L1.39996 8.54956C0.678064 9.51064 0.25 10.7064 0.25 12H1.75ZM10.75 15V2H9.25V15H10.75ZM6.58768 5.46597L7.98553 3.703L6.81016 2.77106L5.41232 4.53403L6.58768 5.46597ZM12.0145 3.703L13.4123 5.46597L14.5877 4.53403L13.1898 2.77106L12.0145 3.703ZM7.98553 3.703C8.55429 2.98568 8.94177 2.49884 9.26822 2.17113C9.59132 1.84678 9.76116 1.77747 9.86734 1.76055L9.63133 0.279232C9.05816 0.370553 8.60963 0.706845 8.20552 1.11252C7.80475 1.51484 7.35616 2.08245 6.81016 2.77106L7.98553 3.703ZM13.1898 2.77106C12.6438 2.08245 12.1953 1.51484 11.7945 1.11252C11.3904 0.706846 10.9418 0.370553 10.3687 0.279232L10.1327 1.76055C10.2388 1.77747 10.4087 1.84678 10.7318 2.17113C11.0582 2.49884 11.4457 2.98568 12.0145 3.703L13.1898 2.77106ZM9.86734 1.76055C9.91168 1.75348 9.95595 1.75 10 1.75V0.25C9.87662 0.25 9.75344 0.259776 9.63133 0.279231L9.86734 1.76055ZM10 1.75C10.0441 1.75 10.0883 1.75348 10.1327 1.76055L10.3687 0.279231C10.2466 0.259776 10.1234 0.25 10 0.25V1.75ZM10.75 2V1H9.25V2H10.75Z"
                          fill="white"
                        />
                      </g>
                    </svg>
                    Register agency
                  </button>
                </div>

                <AgencyRow agencyDetails={agent} />
              </div>
            </div>
          </div>

          <AppModal
            isOpen={isAddAgentOpen}
            //closeModal={closeModal}
            content={
              <AddAgency
                onAgentAdded={(isAgentAdded) => {
                  closeModal();
                  if (isAgentAdded) {
                    agentInit();
                  }
                }}
                onCloseModal={() => closeModal()}
              />
            }
          />
        </Grid>
      </Grid>
    </>
  );
};

export default Agencies;
